// private function
function Scale(map) {
  this.map = map;
  this.units = map.getView().getProjection().getUnits(); // "us-ft" or "m"
  this.multiplier = null;

  if (this.units.indexOf('ft') > -1 ) {  // this picks up "ft" and "us-ft", etc.
    this.multiplier = 12 * 96;
  } else if (this.units === 'm') {
    this.multiplier = 39.37 * 96;
  } else {
    console.error('unknown units:', this.units);
  }

  this.getScale = function() {
    var
      resolution = this.map.getView().getResolution(),
      scale = Math.round(resolution * this.multiplier);
    return scale;
  };
}

// private function copied from OpenLayers 2 lib/OpenLayers/Control/Scale.js
function formatScale(scale) {
  if (scale >= 9500 && scale <= 950000) {
    scale = Math.round(scale / 1000) + 'K';
  } else if (scale >= 950000) {
    scale = Math.round(scale / 1000000) + 'M';
  } else {
    scale = Math.round(scale);
  }
  return scale;
}

/** Constructor - writes scale ratio text to element.innerHTML
 * map: instance of an ol3 map
 * element: HTML element where scale will be displayed
 * usage:   var scaleLabel = new ScaleLable(map, 'scale');
 */
function ScaleLable(map, elementId) {
  var thisScaleLableInstance = this;
  // this.map = map;
  this.scale = new Scale(map);
  // this.setMultiplier();
  this.element = document.getElementById(elementId);
  this.update = function() {
    if (this.element) {
      // var resolution = this.map.getView().getResolution();
      // this.element.innerHTML = 'Scale 1 : ' + Math.round(resolution * this.multiplier);
      let resolution = map.getView().getResolution();
      resolution = resolution > 1 ? Math.round(resolution) : resolution.toFixed(2)
      this.element.innerHTML = 'Scale 1 : ' + formatScale(this.scale.getScale()) +
      ' r: ' + resolution;
    }
  };

  map.getView().on('propertychange', function(e) {
    if (e.key === 'resolution') {
      thisScaleLableInstance.update();
    }
  });

  this.update();
}

export {ScaleLable};
